module.exports = __webpack_public_path__ + "img/button_change_photo.974d9f95.svg";